import React from 'react'
import Footer from '../component/Footer'


const Menupause = () => {
    return (
        <>
            <div className='heading'>
                <h1>Menopause </h1>
                <p>Home / Menopause</p>
            </div>

            <div className='desiese'>

                <div className='desiese1'>

                    <h1>Doctor, I think I am going through menopause. Can you please elaborate on the symptoms of menopause?</h1>
                    <p>Yes, please note the symptoms of the menopause problems are as under:</p>
                    <li>Vaginal Dryness.</li>
                    <li>Irregular Bleeding.</li>
                    <li>Depression and Anxiety.</li>
                    <li>Memory Issues.</li>
                    <li>Reduced Sex Drive.</li>
                    <li>Mood Swings.</li>
                    <li>Night Sweats.</li>
                    <li>Breast soreness.</li>


                    <h1>Doctor, can you tell me why menopause occurs in females?</h1>
                    <p>It is the natural process like others that happens when the ovaries age. A female when start with menopause will produce fewer hormones like estrogen, testosterone, progesterone, follicle-stimulating hormone, and luteinizing hormones. When ovaries get old, they do not release eggs leading to the absence of menstruation.</p>
                    <h1>What are other reasons that can cause menopause in women?</h1>
                    <p>Menopause can also happen when females take certain medications or undergo surgeries. Sometimes ovaries are removed surgically because they stop functioning. Pelvic injuries can also cause menopause that leads to the damage of ovaries.</p>



                </div>

            </div>

            <br />

          <Footer/>
        </>
    )
}

export default Menupause